import "./App.css";
import Home from "./components/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { MobileChatfeed } from "./components/Chat";
import MobileSettingsPage from "./components/MobileSettingsPage";
import { SnackbarProvider } from "notistack";
import License from "./components/License";
import { PresenseProvider } from "./contexts/UserPresenseContext";

function App() {
  return (
    <div className="App">
      <Router>
        <SnackbarProvider transitionDuration={3000}>
          <AuthProvider>
            <PresenseProvider>
              <Switch>
                <Route exact path="/" component={LandingPage} />

                <ProtectedRoute exact path="/h" component={Home} />
                <Route exact path="/settings" component={MobileSettingsPage} />
                <Route exact path="/c/:roomID" component={MobileChatfeed} />

                <Route exact path="/legal/license" component={License} />
              </Switch>
            </PresenseProvider>
          </AuthProvider>
        </SnackbarProvider>
      </Router>
    </div>
  );
}

export default App;
